import { render, staticRenderFns } from "./FichaDesenvolvimentotoEspecialInfantil.vue?vue&type=template&id=69045ccd"
import script from "./FichaDesenvolvimentotoEspecialInfantil.vue?vue&type=script&lang=js"
export * from "./FichaDesenvolvimentotoEspecialInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports